import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { motion } from 'framer-motion';
import { CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getParameterByName } from '@ameroservices-platform/shared/utility/index';
import { selectNavigation } from '@ameroservices-platform/attraction-backend/app/store/fuse/navigationSlice';
import { submitLoginWithToken } from '@ameroservices-platform/attraction-backend/app/auth/store/loginSlice';

function AuthRedirect() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const navigation = useSelector(selectNavigation);
	const user = useSelector(state => state.auth.user);
	const token = getParameterByName('token');
	const redirect = getParameterByName('redirect');
	const [loginStarted, setLoginStarted] = useState(false);
	const isLoggedIn = Boolean(user?.role?.length);

	function getNestedChildren(item) {
		if (item.url) {
			return item.url;
		}
		const children = item.children;
		if (children && children.length > 0) {
			for (const child of children) {
				const nestedUrl = getNestedChildren(child);
				if (nestedUrl) {
					return nestedUrl;
				}
			}
		}
		return null;
	}

	const handleNavigation = useCallback(() => {
		const firstNavWithNestedChildren = navigation.find(
			nav =>
				nav.children &&
				nav.children.length > 0 &&
				nav.children.some(child => child.children && child.children.length > 0)
		);
		if (firstNavWithNestedChildren) {
			console.log('Found navigation with nested children:', firstNavWithNestedChildren);
			const firstChildWithChildren = firstNavWithNestedChildren.children.find(
				child => child.children && child.children.length > 0
			);

			if (
				firstChildWithChildren &&
				firstChildWithChildren.children &&
				firstChildWithChildren.children.length > 0
			) {
				const url = getNestedChildren(firstChildWithChildren);
				console.log('Navigating to first grandchild:', url);
				navigate(url);
			} else {
				console.log(firstNavWithNestedChildren.url);
				navigate(firstNavWithNestedChildren.url);
			}
		} else {
			const firstNavWithChildren = navigation.find(nav => nav.children && nav.children.length > 0);
			if (firstNavWithChildren) {
				console.log('Found navigation with children (no nested children):', firstNavWithChildren);
			} else {
				console.log('No navigation with children found');
			}
		}
	}, [navigation, navigate]);

	useEffect(() => {
		if (!token || loginStarted || isLoggedIn) {
			return;
		}
		setLoginStarted(true);
		dispatch(submitLoginWithToken({ token }));
	}, [token, loginStarted, isLoggedIn, dispatch]);

	useEffect(() => {
		if (!redirect || !isLoggedIn) {
			return;
		}
		window.location.href = `/${redirect.replace(/^\//, '')}`;
	}, [redirect, isLoggedIn]);

	useEffect(() => {
		if (redirect) {
			return;
		}
		if (navigation && navigation.length > 0) {
			const userNav = navigation.find(nav => nav.id === 'user');
			if (
				userNav &&
				userNav.children &&
				userNav.children.every(child => child.auth && child.auth.includes('events.view'))
			) {
				handleNavigation();
			}
		}
	}, [navigation, handleNavigation, redirect]);

	return (
		<div className="flex flex-col flex-auto items-center justify-center shrink-0 p-16 md:p-24">
			<motion.div
				initial={{ opacity: 0, scale: 0.6 }}
				animate={{ opacity: 1, scale: 1 }}
				className="min-w-400 rounded-20 shadow-2xl overflow-hidden"
			>
				<Card className="flex flex-col w-full max-w-sm items-center justify-center shadow-0" square>
					<CardContent className="flex flex-col items-center justify-center w-full pt-48 max-w-320">
						<div className="max-w-320">
							<div className={'flex justify-center w-full mb-32'}>
								<CircularProgress size={60} />
							</div>
							<motion.div
								initial={{ opacity: 0, y: 40 }}
								animate={{
									opacity: 1,
									y: 0,
									transition: { delay: 0.2 }
								}}
							>
								<Typography
									variant="h5"
									color="inherit"
									className="font-semibold leading-tight text-center"
								>
									Indlæser...
								</Typography>
							</motion.div>

							<motion.div
								initial={{ opacity: 0 }}
								animate={{
									opacity: 1,
									transition: { delay: 0.3 }
								}}
							>
								<Typography variant="subtitle1" color="inherit" className="mt-10 text-center">
									Dette tager et øjeblik, tak for din tålmodighed.
								</Typography>
							</motion.div>
						</div>
					</CardContent>
				</Card>
			</motion.div>
		</div>
	);
}

export default AuthRedirect;
